import React from "react";
import Common from "./common/index";

const index: React.FC = () => {
  return <Common />;
};

export default index;
